function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath96"
}, /*#__PURE__*/React.createElement("path", {
  d: "m462.36 330.87h404.5v223.66h-404.5z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-51.201 -98.993)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 -131.65 274.84)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clipPath96)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(810.9 442.65)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c0-30.828-37.047-55.819-82.749-55.819-45.7 0-82.747 24.991-82.747 55.819 0 30.829 37.047 55.82 82.747 55.82 45.702 0 82.749-24.991 82.749-55.82",
  fill: "#00984f"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(683.82 442.65)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c0-30.828-37.048-55.819-82.749-55.819-45.7 0-82.748 24.991-82.748 55.819 0 30.829 37.048 55.82 82.748 55.82 45.701 0 82.749-24.991 82.749-55.82",
  fill: "#00984f"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(560.39 448.96)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c-4.917 1.328-7.901 2.317-7.901 4.841 0 2.096 2.093 3.45 5.333 3.45 3.234 0 6.504-1.223 9.206-3.442l0.073-0.059 0.318 6.191 2e-3 0.03-0.026 0.015c-2.592 1.429-5.189 2.381-9.439 2.381-3.075 0-5.875-0.789-7.885-2.222-2.205-1.573-3.371-3.829-3.371-6.524 0-5.324 4.432-7.597 8.149-8.564 4.969-1.334 8.486-2.517 8.486-5.604 0-2.599-2.302-4.212-6.007-4.212-3.712 0-7.491 1.597-10.368 4.38l-0.072 0.069-0.592-6.6-2e-3 -0.027 0.023-0.015c2.953-2.001 6.683-3.059 10.788-3.059 3.465 0 6.433 0.849 8.58 2.455 2.309 1.724 3.528 4.256 3.528 7.322 0 4.686-2.887 7.693-8.823 9.194",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(591.22 442.64)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c0 4.613-2.786 7.673-6.76 7.673-2.374 0-4.658-1.051-6.302-3.472v-8.722c1.644-2.101 3.882-3.152 6.349-3.152 3.927 0 6.713 3.061 6.713 7.673m5.709 0c0-8.267-5.344-12.606-11.601-12.606-3.014 0-5.389 1.096-7.17 2.651v-9.653h-5.663v31.757h5.663v-2.649c1.873 1.827 4.43 3.105 7.581 3.105 6.12 0 11.19-4.338 11.19-12.605",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(618.03 445.38)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c0 2.969-1.872 5.253-5.343 5.253-3.288 0-6.12-2.238-6.851-5.938h12.103c0.046 0.228 0.091 0.412 0.091 0.685m4.841-4.567h-17.126c0.64-3.791 3.425-5.846 7.262-5.846 3.288 0 5.618 0.776 8.22 2.283l0.32-4.977c-2.283-1.279-5.207-2.239-8.951-2.239-6.942 0-12.651 4.339-12.651 12.515 0 7.581 5.754 12.696 12.605 12.696 7.125 0 10.824-4.292 10.824-10.55 0-1.279-0.137-2.512-0.503-3.882",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(649.96 432.59)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0 0.594 5.481c2.283-1.965 5.48-3.106 8.815-3.106 2.375 0 4.018 1.004 4.018 2.695 0 4.521-13.061 2.192-13.061 10.321 0 4.887 4.202 7.262 9.225 7.262 3.517 0 6.211-0.868 8.268-2.147l-0.276-5.069c-2.42 1.644-5.343 2.467-7.946 2.467-2.009 0-3.654-0.777-3.654-2.33 0-3.791 13.109-1.964 13.109-10.321 0-5.161-4.522-7.811-9.775-7.811-3.882 0-7.033 1.006-9.317 2.558",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(688.05 437.07)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0v3.654c-2.055 0.639-3.972 1.05-5.983 1.05-2.923 0-4.658-1.507-4.658-3.699 0-2.238 1.919-3.655 4.43-3.655 2.375 0 4.247 0.823 6.211 2.65m5.618 8.494v-15.071h-5.618v2.467c-1.873-1.782-4.384-2.924-7.307-2.924-5.435 0-8.768 3.289-8.768 7.856 0 4.887 3.79 7.855 9.453 7.855 2.146 0 4.202-0.365 6.622-1.095v0.73c0 3.699-2.785 5.343-6.257 5.343-2.603 0-5.572-0.958-7.673-2.648l-0.227 4.933c1.826 1.233 5.206 2.237 8.905 2.237 6.303 0 10.87-2.923 10.87-9.683",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(694.17 454.79)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0h6.158l6.978-15.345 6.932 15.345h6.157l-11.538-24.298h-3.147z",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(737.71 445.38)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c0 2.969-1.873 5.253-5.343 5.253-3.289 0-6.12-2.238-6.851-5.938h12.103c0.045 0.228 0.091 0.412 0.091 0.685m4.841-4.567h-17.126c0.64-3.791 3.425-5.846 7.261-5.846 3.288 0 5.618 0.776 8.221 2.283l0.319-4.977c-2.283-1.279-5.207-2.239-8.95-2.239-6.942 0-12.651 4.339-12.651 12.515 0 7.581 5.754 12.696 12.604 12.696 7.126 0 10.825-4.292 10.825-10.55 0-1.279-0.138-2.512-0.503-3.882",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(763.84 454.2)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0-0.777-5.206c-1.371 0.73-2.649 1.005-4.064 1.005-2.513 0-4.796-1.279-6.44-3.929v-15.574h-5.664v24.298h5.664v-3.288c1.598 2.237 3.927 3.745 7.125 3.745 1.553 0 2.876-0.366 4.156-1.051",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(765.47 432.59)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0 0.592 5.481c2.285-1.965 5.481-3.106 8.815-3.106 2.375 0 4.019 1.004 4.019 2.695 0 4.521-13.06 2.192-13.06 10.321 0 4.887 4.2 7.262 9.224 7.262 3.516 0 6.211-0.868 8.267-2.147l-0.275-5.069c-2.421 1.644-5.343 2.467-7.946 2.467-2.01 0-3.654-0.777-3.654-2.33 0-3.791 13.107-1.964 13.107-10.321 0-5.161-4.521-7.811-9.774-7.811-3.881 0-7.032 1.006-9.315 2.558",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(645.81 437.14)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c-1.955-1.41-3.943-2.177-6.27-2.177-3.927 0-7.353 2.74-7.353 7.673 0 4.932 3.426 7.673 7.353 7.673 2.328 0 4.316-0.767 6.273-2.144 0.247 1.698 0.62 3.37 1.088 5.02-2.027 1.187-4.482 2.056-7.954 2.056-6.943 0-12.561-4.704-12.561-12.605s5.618-12.606 12.561-12.606c3.491 0 5.927 0.968 7.915 2.212-0.449 1.61-0.811 3.241-1.052 4.898",
  fill: "#fff"
})))));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "103.22mm",
    height: "39.384mm",
    viewBox: "0 0 103.22 39.384",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Logo.1bb5a181.svg";
export { ForwardRef as ReactComponent };